import React, { Component, useState } from "react";
import HttpService from "../services/HttpService";
//import { process.env.REACT_APP_API_URL } from "../Globals";
import "../css/index.css";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import RenderOnRole from "../Utilities/RenderOnRole";
import BerichtRow from "../Components/DashboardKlant/BerichtRow";
//import { RetryTooltip } from "../Components/DashboardKlant/RetryTooltip";
import RetryPopup from "../Components/DashboardKlant/RetryPopup";
import { saveAs } from "file-saver";
import UserService from "../services/UserService";

class BerichtDownloadPagina extends Component {
  state = {
    loading: false,
    error: null,
    interface: null,
    berichten: null,
    displayBerichten: null,
    sorting: "",
    selectedBerichten: [],
    selectedFile: null,
    fileContent: "",
    downloadedFiles: [],
    retriedMessages: []
  };

  componentDidMount() {
    const httpService = HttpService;
    httpService.configure();
    this.state.axios = httpService.getAxiosClient();

    this.state.interface = this.props.interface;
    let url =
      process.env.REACT_APP_API_URL +
      `/Berichten?InterfaceId=` +
      this.state.interface.id +
      `&voorMaand=true`;
    this.setState({
      loading: true,
      berichten: null,
      error: null,
    });
    this.state.axios
      .get(url)
      .then((response) => {
        this.setState({
          berichten: JSON.parse(JSON.stringify(response.data)),
          displayBerichten: JSON.parse(JSON.stringify(response.data)),
          error: null,
          loading: false,
        });
        this.props.scroll();
      })
      .catch((err) => {
        this.setState({
          berichten: null,
          error: err.message,
          loading: false,
        });
      });
  }

  handleSelect = (bericht) => {
    let selectedBerichten = this.state.selectedBerichten;
    if (selectedBerichten.some(m => m.id === bericht.id)) {
      var removeIndex = selectedBerichten.findIndex(b => b.id == bericht.id);
      selectedBerichten.splice(removeIndex, 1);
    }
    else {
      selectedBerichten = selectedBerichten.concat([bericht])
    }
    this.setState({ selectedBerichten: selectedBerichten });
  };

  onchangeSearchHandler(target) {
    var targetName = target.name;
    var targetValue = target.value;
    if (targetValue == null || targetValue.length < 1) {
      this.state.displayBerichten = this.state.berichten;
    }
    if (targetName == "txtFunctioneelId") {
      let newDisplayBerichten = [...this.state.berichten].filter(function (
        bericht
      ) {
        return bericht.functioneelID.toString().includes(targetValue);
      });

      this.setState({
        displayBerichten: newDisplayBerichten,
      });
    }
  }

  handleHeaderClick(header) {
    let berichten = this.state.displayBerichten;
    let newdata = [];
    if (this.state.sorting == header) {
      if (header == "verzonden_datumtijd") {
        newdata = [...berichten].sort(
          (a, b) => new Date(b[header]) - new Date(a[header])
        );
      } else if (
        header == "displayNaamVerzend" ||
        header == "displayNaamOntvangt" ||
        header == "status"
      ) {
        newdata = [...berichten].sort((a, b) =>
          String(b[header]).localeCompare(String(a[header]))
        );
      } else {
        newdata = [...berichten].sort((a, b) => b[header] - a[header]);
      }
      header = "";
    } else {
      if (header == "verzonden_datumtijd") {
        newdata = [...berichten].sort(
          (a, b) => new Date(a[header]) - new Date(b[header])
        );
      } else if (
        header == "displayNaamVerzend" ||
        header == "displayNaamOntvangt" ||
        header == "status"
      ) {
        newdata = [...berichten].sort((a, b) =>
          String(a[header]).localeCompare(String(b[header]))
        );
      } else {
        newdata = [...berichten].sort((a, b) => a[header] - b[header]);
      }
    }
    this.setState({
      displayBerichten: newdata,
      sorting: header,
    });
  }

  async DownloadClicked() {
    if (UserService.hasRole(["SD_Medewerker", "Administrator", "Download","Download_compleet"])) {
      let berichten = this.state.selectedBerichten;
      //download alle geselecteerde berichten
      for (let m = 0; m < berichten.length; m++) {

        let connectmessageId = berichten[m].connectmessageId;
        let verzender = berichten[m].verzend_rela_naam;
        let ontvanger = berichten[m].ontvangt_rela_naam;
        let verzondenTijd = berichten[m].verzonden_datumtijd;
        let functioneelId = berichten[m].functioneelID;
        let berichtId = berichten[m].id;

        let url =
          process.env.REACT_APP_API_URL +
          `/Berichten?InterfaceId=` +
          this.state.interface.id +
          `&connectmessageId=` +
          connectmessageId +
          `&berichtId=` +
          berichtId;
        this.setState({
          loading: true,
          error: null,
        });
        await this.state.axios
          .get(url)
          .then((response) => {
            this.setState({
              loading: false,
            });
            let message = {
              functioneelId: functioneelId,
              files: [],
              success: true
            }
            if (response.status == 200) {
              for (let i = 0; i < response.data.length; i++) {

                let data = response.data[i].messageText;
                let messageType = response.data[i].fileExtension;
                let tag = response.data[i].tag;

                let fileName = "";
                //als de gebruiker een supplydrive medewerker is mag de tag (pickup, output of connectmessage toegevoegd worden)
                if (UserService.hasRole(["SD_Medewerker", "Administrator", "Download_compleet"])) {
                  fileName += tag;
                }

                //als het functioneel id bekend is word dit de file name
                if (functioneelId != null && functioneelId != "") {
                  fileName += "_" + functioneelId;
                }
                //anders dit
                else {
                  fileName +=
                    verzender + "_naar_" + ontvanger + " " + verzondenTijd;
                }

                let file = {
                  fileName: fileName,
                  data: data,
                  messageType: messageType
                }
                message.files.push(file);
              }
            } else {
              message.success = false;
            }
            this.setState({
              downloadedFiles: this.state.downloadedFiles.concat([message])
            });
            // if(this.state.downloadedFiles.length==berichten.length){
            //   this.DownloadFiles();
            // }
          })
          .catch((err) => {
            console.log(err.response);
            this.setState({
              error: err.response.data,
              loading: false,
            });
          });
      }
      this.DownloadFiles();
    }
  }

  DownloadFiles() {
    let downloadedFiles = this.state.downloadedFiles;
    for (let m = 0; m < downloadedFiles.length; m++) {

      let message = downloadedFiles[m];

      for (let f = 0; f < message.files.length; f++) {
        let file = message.files[f];
        if (file.messageType == "xml") {
          var blob = b64toBlob(file.data, "text/plain;charset=utf-8");
          saveAs(blob, file.fileName + ".xml");
        }
        if (file.messageType == "xlsx") {
          var blob = b64toBlob(
            file.data,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
          saveAs(blob, file.fileName + ".xlsx");
        }
        if (file.messageType == "pdf") {
          var blob = b64toBlob(file.data, "application/pdf");
          saveAs(blob, file.fileName + ".pdf");
        }
        if (file.messageType == "txt") {
          var blob = b64toBlob(file.data, "text/plain;charset=utf-8");
          saveAs(blob, file.fileName + ".txt");
        }
        if (file.messageType == "json") {
          var blob = b64toBlob(file.data, "application/json");
          saveAs(blob, file.fileName + ".json");
        }
      }
    }
    this.setState({
      downloadedFiles: []
    });
  }

  ShowDownloadDialogue() {

  }

  ResendMessage(event, newMessage) {
    event.stopPropagation();
    let message = "";
    if (newMessage) {
      if (this.state.fileContent) {
        message = this.state.fileContent;
      }
      else {
        let message = {
          functioneelId: "leeg",
          success: false,
          status: "Geen geldig bestand geselecteerd."
        }
        this.setState({
          retriedMessages: this.state.retriedMessages.concat([message]),
          loading: false,
        });
        return;
      }
    }

    if (UserService.hasRole(["SD_Medewerker", "Administrator", "Retry"])) {

      let body = '{"message":"' + message + '"}';
      const jsonObject = JSON.stringify({ message: message });

      let berichten = this.state.selectedBerichten;

      //Bericht met correctie kan ook zonder een bericht te selecteren

      if(newMessage&&berichten.length<1){
        let bericht = {
          connectmessageId: 0,
          id: 0
        }
        berichten.push(bericht);
      }
      
      for (let m = 0; m < berichten.length; m++) {
        let connectmessageId = berichten[m].connectmessageId
        let berichtId = berichten[m].id;
        let url =
          process.env.REACT_APP_API_URL +
          `/Berichten/Retry?InterfaceId=` +
          this.state.interface.id +
          `&ConnectmessageId=` +
          connectmessageId +
          `&berichtId=` +
          berichtId;
        this.setState({
          loading: true,
          error: null,
          retriedMessages: []
        });
        this.state.axios
          .post(url, jsonObject, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then((response) => {
            let message = {
              functioneelId: berichten[m].functioneelID,
              success: true,
              status: "Bericht opnieuw verstuurd naar connectplaza."
            }
            this.setState({
              retrySuccess: response.data,
              retryError: null,
              loading: false,
              retriedMessages: this.state.retriedMessages.concat([message])
            });
          })
          .catch((err) => {
            console.log(err.response);
            if (err.response && err.response.data) {
              let message = {
                functioneelId: berichten[m].functioneelID,
                success: false,
                status: err.response.data
              }
              this.setState({
                retriedMessages: this.state.retriedMessages.concat([message]),
                loading: false,
              });
            }
            else {
              let message = {
                functioneelId: berichten[m].functioneelID,
                success: false,
                status: "Retry was niet successvol, geen reactie van de server."
              }
              this.setState({
                retriedMessages: this.state.retriedMessages.concat([message]),
                loading: false,
              });
            }
          });
      }
    }
  }

  handleFileChange = (event) => {
    event.stopPropagation();
    const file = event.target.files[0];
    this.setState({ selectedFile: file });

    if (file) {
      const reader = new FileReader();
      reader.onload = this.handleFileRead;
      reader.readAsText(file);
    }
  }

  handleFileRead = (event) => {
    const content = event.target.result;
    this.setState({ fileContent: content });
  }

  render() {
    if (
      !this.state.loading &&
      !this.state.error &&
      this.state.berichten != null
    ) {
      let selectedBerichten = this.state.selectedBerichten;
      return (
        <div class="grid grid-cols-8 m-4">
          <div class="col-span-8">
            <div class="m-2 font-bold">Berichten</div>
            <div class="grid grid-cols-8">
              <input
                class="border border-black m-2 col-span-1"
                onChange={(e) => this.onchangeSearchHandler(e.target)}
                type="text"
                name="txtFunctioneelId"
                placeholder="FunctioneelId"
              />
              <div className="col-span-1" />
              <RenderOnRole roles={["SD_Medewerker", "Administrator", "Download", "Download_compleet"]}>
                <button
                  className="bg-blue-400 border-black border mr-5 col-span-1"
                  onClick={() =>
                    this.DownloadClicked()
                  }
                  style={{cursor:'pointer'}}
                >
                  Download
                </button>
              </RenderOnRole>
              <RenderOnRole roles={["SD_Medewerker", "Administrator", "Retry"]}>
                {this.state.interface.listener ?
                  <div className="col-span-4 grid grid-cols-4">
                      <button
                        className="bg-blue-400 border-black border mr-5 col-span-1"
                        onClick={(e) =>
                          this.ResendMessage(e, false)
                        }
                      >
                        Retry
                      </button>
                      <input
                        className="col-span-2"
                        onChange={this.handleFileChange}
                        type="file"
                      //ref={this.fileInputRef}
                      />
                      <button
                        className="bg-blue-400 border-black border ml-5 col-span-1"
                        onClick={(e) =>
                          this.ResendMessage(e, true)
                        }
                      >
                        Retry met correctie
                      </button>
                  </div>
                  : null}

                {this.state.retriedMessages.length > 0 ? <RetryPopup messages={this.state.retriedMessages} /> : null}

              </RenderOnRole>
            </div>
            <div class="mt-3">
              <div class="inline-block rounded-lg w-full bg-blue-100 border-2 border-black shadow-2xl">
                <Table name="BerichtenTable" class="w-full">
                  <TableHead>
                    <TableRow class="bg-blue-200" style={{ textAlign: "left" }}>
                      <TableCell
                        class="font-semibold"
                      />
                      <TableCell
                        class="font-semibold"
                        style={{ paddingLeft: "15px" }}
                        onClick={() =>
                          this.handleHeaderClick("displayNaamVerzend")
                        }
                      >
                        Verzender naam
                      </TableCell>
                      <TableCell
                        class="font-semibold"
                        style={{ paddingLeft: "15px" }}
                        onClick={() => this.handleHeaderClick("glN_zender")}
                      >
                        SCSN nr
                      </TableCell>
                      <TableCell
                        class="font-semibold "
                        style={{ paddingLeft: "15px" }}
                        onClick={() =>
                          this.handleHeaderClick("displayNaamOntvangt")
                        }
                      >
                        Ontvanger naam
                      </TableCell>
                      <TableCell
                        class="font-semibold"
                        style={{ paddingLeft: "15px" }}
                        onClick={() => this.handleHeaderClick("glN_ontvanger")}
                      >
                        SCSN nr
                      </TableCell>
                      <TableCell
                        class="font-semibold "
                        style={{ paddingLeft: "15px" }}
                        onClick={() => this.handleHeaderClick("functioneelID")}
                      >
                        FunctioneelID
                      </TableCell>
                      <TableCell
                        class="font-semibold "
                        style={{ paddingLeft: "15px" }}
                        onClick={() => this.handleHeaderClick("status")}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        class="font-semibold "
                        style={{ paddingLeft: "15px" }}
                        onClick={() =>
                          this.handleHeaderClick("verzonden_datumtijd")
                        }
                      >
                        Ontvangen
                      </TableCell>
                      <TableCell
                        class="font-semibold "
                        style={{ paddingLeft: "15px" }}
                        onClick={() =>
                          this.handleHeaderClick("verzonden_datumtijd")
                        }
                      >
                        Laatste update
                      </TableCell>
                      <RenderOnRole roles={["SD_Medewerker", "Administrator"]}>
                        <TableCell
                          class="font-semibold "
                          style={{ paddingLeft: "15px" }}
                          onClick={() => this.handleHeaderClick("agentname")}
                        >
                          Agent
                        </TableCell>

                      </RenderOnRole>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.displayBerichten.length > 0
                      ? this.state.displayBerichten.map(
                        (bericht, index) => (
                          console.log(bericht),
                          (
                            <BerichtRow
                              key={index}
                              bericht={bericht}
                              interfaceId={this.state.interface.id}
                              onSelect={this.handleSelect}
                              isSelected={this.state.selectedBerichten.some(m => m.id === bericht.id)}

                            />
                          )
                        )
                      )
                      : null}
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (this.state.error) {
      return <div>Er is iets mis gegaan: {this.state.error}</div>;
    }
    if (this.state.loading) {
      return <div>Loading...</div>;
    }
    return <div>Berichten niet beschikbaar.</div>;
  }
}
export default BerichtDownloadPagina;

function b64toBlob(b64Data, contentType) {
  contentType = contentType || "";
  var sliceSize = 512;
  b64Data = b64Data.replace(/^[^,]+,/, "");
  b64Data = b64Data.replace(/\s/g, "");
  var byteCharacters = window.atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
}